import { render, staticRenderFns } from "./WelcomeGreeting.vue?vue&type=template&id=473c6e7c&"
import script from "./WelcomeGreeting.vue?vue&type=script&lang=js&"
export * from "./WelcomeGreeting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports